var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4542 5.37544L11.8323 1.7536C11.5335 1.45475 11.2303 1.30322 10.9314 1.30322C10.5209 1.30322 10.0417 1.61541 10.0417 2.49529V3.72832C7.41028 3.843 4.95294 4.92216 3.07869 6.79632C1.09356 8.78132 0.0001875 11.4205 0 14.2278C0 14.4295 0.129 14.6087 0.320312 14.6725C0.369156 14.6888 0.419156 14.6966 0.468688 14.6966C0.613281 14.6966 0.75325 14.6295 0.8435 14.5094C3.05659 11.5636 6.38847 9.82269 10.0417 9.68525V10.8993C10.0417 11.7791 10.5209 12.0914 10.9314 12.0914H10.9315C11.2304 12.0914 11.5335 11.9398 11.8323 11.641L15.4541 8.01913C15.8062 7.66722 16 7.19779 16 6.69729C16 6.19688 15.8062 5.72741 15.4542 5.37544Z",
    fill: "#9027E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkShare);
export default __webpack_public_path__ + "static/media/pink-share.079fe1583175cabf783ca8cb0ba097b0.svg";
export { ForwardRef as ReactComponent };